module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticStyle: {
      "font-size": "small",
      "font-weight": "bold",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("DEDICATION")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-t"
  }, [_vm._v("T")])])]), _c('span', {
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v("his series is dedicated to all of the strong women who have had to face bullying, are facing bullying, and who have had to overcome it. ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("SERIES BLURB")]), _vm._v(" "), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "font-size": "x-small",
      "font-style": "italic"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-a"
  }, [_vm._v("A")]), _vm._v("S VIOLET KINGSBURY")]), _vm._v(", I was born to be a kingmaker. In a time when wars were common and thrones were fought after, the only name that could bring about peace...the only man that could trump the decrees of kings was Kingsbury. The Kingmaker. But when the legendary Kingmaker is disposed, and the time of the Choosing has come, can I, the daughter of The Kingmaker rise to take the place of my father? I am about to find out as the strongest, most capable, and most legendary princes across the lands come to challenge me for the Choosing including 4 of the most handsome princes who not only wants to win, but to want to win me, too: ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-small",
      "font-style": "italic"
    }
  }, [_vm._v("Avery")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-small",
      "font-style": "italic"
    }
  }, [_vm._v("Axel ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-small",
      "font-style": "italic"
    }
  }, [_vm._v("Reggie ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-small",
      "font-style": "italic"
    }
  }, [_vm._v("Ollie ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-small",
      "font-style": "italic"
    }
  }, [_vm._v("Becoming Kingmaker, even as The Kingmaker's daughter, will not be easy in a male world where ladies were supposed to be damsels who needed saving. To become Kingmaker, I will prove to all, especially the princes, that I am here to stay, and will be the one doing the saving. **Kingmaker's Kings is the first book in the Kingmakers of Kingsbury Series, a Reverse Harem Bully Romance with mixed genres elements, action, and mature scenes recommended for age 17 and up.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26b8d63c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c003.vue
// module id = 66
// module chunks = 0